export const SelectedNodesService = Symbol.for('SelectedNodesService');
